module.exports = __webpack_public_path__ + "assets/styled-components.547ceb3e.svg";